import i18n from '../i18n'

function getStoreDescription (store) {
  if (!store) return ''
  if (store.isReceiptDuctable) {
    return `(${i18n.t('receiptInvoiceTypeDeductible')})`
  } else if (store.isReceiptDisductable) {
    return `(${i18n.t('receiptInvoiceTypeNonDeductible')})`
  } else if (store.isInvoiceable) {
    return `(${i18n.t('receiptInvoiceTypeInvoice')})`
  } else {
    return `(${i18n.t('receiptInvoiceTypeNo')})`
  }
}

export default {
  getStoreDescription
}
